var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"layout-vertical",class:{ 'is-loading': _vm.isLoading },style:(_vm.styles)},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_vm._v(" "),(_vm.$slots.switcher)?_c('div',{staticClass:"switcher"},[_vm._t("switcher")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prices"},[_vm._t("prices")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }